module.exports = __webpack_public_path__ + "assets/img/89d67cd714d274321c1406ca6f34ad81.png";